// document.addEventListener("DOMContentLoaded", function () {
//   const slides = document.querySelectorAll(".ikm-hero-slide");
//   const dotsBox = document.querySelector(".ikm-hero-dots");
//   const sliderWrapper = document.querySelector(".ikm-hero-img-div");

//   if (!slides.length || !dotsBox || !sliderWrapper) return;

//   let index = 0;
//   let startX = 0;
//   let startY = 0;
//   let isDragging = false;
//   let isSwipingHorizontally = false;
//   const SWIPE_THRESHOLD = 40;

//   /* ── dots ── */
//   slides.forEach(function (slide, i) {
//     var dot = document.createElement("div");
//     dot.classList.add("ikm-hero-dot");
//     if (i === 0) dot.classList.add("active");
//     dotsBox.appendChild(dot);
//     dot.addEventListener("click", function () {
//       index = i;
//       showSlide();
//     });
//   });

//   var dots = document.querySelectorAll(".ikm-hero-dot");

//   function showSlide() {
//     slides.forEach(function (s) { s.classList.remove("active"); });
//     dots.forEach(function (d) { d.classList.remove("active"); });
//     slides[index].classList.add("active");
//     dots[index].classList.add("active");
//   }

//   function nextSlide() {
//     index = (index + 1) % slides.length;
//     showSlide();
//   }

//   function prevSlide() {
//     index = (index - 1 + slides.length) % slides.length;
//     showSlide();
//   }

//   /* ── autoplay ── */
//   var autoplayTimer = setInterval(nextSlide, 3000);

//   function resetAutoplay() {
//     clearInterval(autoplayTimer);
//     autoplayTimer = setInterval(nextSlide, 3000);
//   }

//   /* ── swipe / drag (pointer events = mouse + touch) ── */
//   sliderWrapper.addEventListener("pointerdown", function (e) {
//     // Don't treat taps/clicks on dots as a swipe.
//     if (e.target && e.target.closest && e.target.closest(".ikm-hero-dot")) return;
//     // Only handle the primary pointer for mouse.
//     if (e.pointerType === "mouse" && e.button !== 0) return;

//     startX = e.clientX;
//     startY = e.clientY;
//     isDragging = true;
//     isSwipingHorizontally = false;
//     clearInterval(autoplayTimer); // avoid autoplay changing slides mid-gesture
//     sliderWrapper.setPointerCapture(e.pointerId);
//   });

//   sliderWrapper.addEventListener("pointerup", function (e) {
//     if (!isDragging) return;
//     isDragging = false;

//     var diffX = e.clientX - startX;
//     // Only change slides for horizontal swipes.
//     if (isSwipingHorizontally && Math.abs(diffX) >= SWIPE_THRESHOLD) {
//       if (diffX < 0) {
//         nextSlide();
//       } else {
//         prevSlide();
//       }
//     }

//     resetAutoplay(); // always resume autoplay after interaction
//   });

//   sliderWrapper.addEventListener(
//     "pointermove",
//     function (e) {
//       if (!isDragging) return;

//       var dx = e.clientX - startX;
//       var dy = e.clientY - startY;

//       // Lock into horizontal swiping once horizontal intent is clear.
//       // (Preventing too early can block vertical scroll.)
//       if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
//         isSwipingHorizontally = true;
//         e.preventDefault(); // stop native horizontal rubber-band/stretch
//       }
//     },
//     { passive: false }
//   );

//   sliderWrapper.addEventListener("pointercancel", function () {
//     isDragging = false;
//     isSwipingHorizontally = false;
//     resetAutoplay();
//   });

//   /* prevent native image drag inside slider */
//   sliderWrapper.addEventListener("dragstart", function (e) {
//     e.preventDefault();
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".ikm-hero-slide");
  const dotsBox = document.querySelector(".ikm-hero-dots");
  const sliderWrapper = document.querySelector(".ikm-hero-img-div");

  if (!slides.length || !dotsBox || !sliderWrapper) return;

  let index = 0;
  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let isSwipingHorizontally = false;
  let suppressClick = false;
  const SWIPE_THRESHOLD = 40;

  /* ── dots ── */
  slides.forEach(function (slide, i) {
    var dot = document.createElement("div");
    dot.classList.add("ikm-hero-dot");
    if (i === 0) dot.classList.add("active");
    dotsBox.appendChild(dot);
    dot.addEventListener("click", function () {
      index = i;
      showSlide();
    });
  });

  var dots = document.querySelectorAll(".ikm-hero-dot");

  function showSlide() {
    slides.forEach(function (s) { s.classList.remove("active"); });
    dots.forEach(function (d) { d.classList.remove("active"); });
    slides[index].classList.add("active");
    dots[index].classList.add("active");
  }

  function nextSlide() {
    index = (index + 1) % slides.length;
    showSlide();
  }

  function prevSlide() {
    index = (index - 1 + slides.length) % slides.length;
    showSlide();
  }

  /* ── autoplay ── */
  var autoplayTimer = setInterval(nextSlide, 3000);

  function resetAutoplay() {
    clearInterval(autoplayTimer);
    autoplayTimer = setInterval(nextSlide, 3000);
  }

  /* ── suppress link click after a real swipe ── */
  sliderWrapper.addEventListener("click", function (e) {
    if (suppressClick) {
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }
  }, true);

  /* ── swipe / drag (pointer events = mouse + touch) ── */
  sliderWrapper.addEventListener("pointerdown", function (e) {
    if (e.target && e.target.closest && e.target.closest(".ikm-hero-dot")) return;
    if (e.pointerType === "mouse" && e.button !== 0) return;

    startX = e.clientX;
    startY = e.clientY;
    isDragging = true;
    isSwipingHorizontally = false;
    clearInterval(autoplayTimer);
    // NOTE: no setPointerCapture here anymore
  });

  sliderWrapper.addEventListener("pointerup", function (e) {
    if (!isDragging) return;
    isDragging = false;

    var diffX = e.clientX - startX;
    if (isSwipingHorizontally && Math.abs(diffX) >= SWIPE_THRESHOLD) {
      suppressClick = true;
      if (diffX < 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }

    if (sliderWrapper.hasPointerCapture(e.pointerId)) {
      sliderWrapper.releasePointerCapture(e.pointerId);
    }
    resetAutoplay();
  });

  sliderWrapper.addEventListener(
    "pointermove",
    function (e) {
      if (!isDragging) return;

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        if (!isSwipingHorizontally) {
          // only capture once we know it's a real swipe, not a click
          sliderWrapper.setPointerCapture(e.pointerId);
        }
        isSwipingHorizontally = true;
        e.preventDefault();
      }
    },
    { passive: false }
  );

  sliderWrapper.addEventListener("pointercancel", function (e) {
    isDragging = false;
    isSwipingHorizontally = false;
    if (sliderWrapper.hasPointerCapture(e.pointerId)) {
      sliderWrapper.releasePointerCapture(e.pointerId);
    }
    resetAutoplay();
  });

  /* prevent native image drag inside slider */
  sliderWrapper.addEventListener("dragstart", function (e) {
    e.preventDefault();
  });
});